import React from "react";
import { Link } from "react-router-dom";
import { Plus, Sparkles } from "lucide-react";
import { useCart } from "@/context/CartContext";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const front = product.images?.[0]?.url;
  const meta = [product.year, product.manufacturer, product.card_set]
    .filter(Boolean)
    .join(" · ");

  return (
    <div
      data-testid={`product-card-${product.sku}`}
      className="group card-tilt rounded-2xl bg-[color:var(--charcoal)] border border-[color:var(--line)] overflow-hidden flex flex-col"
    >
      <Link to={`/product/${product.slug}`} className="relative block">
        <div className="aspect-[4/5] bg-[color:var(--ink-2)] overflow-hidden flex items-center justify-center">
          {front ? (
            <img
              src={front}
              alt={product.title}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          ) : (
            <span className="text-[color:var(--chrome-3)] text-xs">No image</span>
          )}
        </div>
        {product.cardscience_select && (
          <span className="absolute top-3 left-3 select-badge flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-bold shadow-lg">
            <Sparkles size={11} /> SELECT™
          </span>
        )}
        {product.graded && product.grade_label && product.grade_label !== "Raw" && (
          <span className="absolute top-3 right-3 rounded-full px-2.5 py-1 text-[10px] font-bold bg-black/70 text-white border border-white/15 font-tech">
            {product.grade_label}
          </span>
        )}
      </Link>

      <div className="p-4 flex flex-col flex-1">
        {meta && (
          <p className="text-[11px] font-tech tracking-wide text-[color:var(--chrome-3)] mb-1 truncate">
            {meta}
          </p>
        )}
        <Link to={`/product/${product.slug}`}>
          <h3 className="text-sm font-semibold text-white leading-snug line-clamp-2 hover:text-[color:var(--cyan)] transition-colors">
            {product.title}
          </h3>
        </Link>
        {(product.player || product.character || product.card_number) && (
          <p className="text-xs text-[color:var(--chrome-3)] mt-1">
            {product.player || product.character}
            {product.card_number ? ` · #${product.card_number}` : ""}
          </p>
        )}

        <div className="mt-auto pt-4 flex items-end justify-between">
          <div>
            {product.cardscience_select && product.reference_price != null && (
              <p className="text-[11px] text-[color:var(--chrome-3)] line-through">
                Ref ${product.reference_price.toFixed(2)}
              </p>
            )}
            <p className="text-lg font-display font-extrabold text-white">
              ${product.price.toFixed(2)}
            </p>
          </div>
          <button
            data-testid={`add-to-cart-${product.sku}`}
            onClick={() => addItem(product)}
            className="btn-holo rounded-lg h-9 w-9 flex items-center justify-center"
            aria-label="Add to cart"
          >
            <Plus size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};
